import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_3 = {
  key: 1,
  class: "text-body-2 text-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_col, { class: "pageStyle" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                ref: "formRef",
                modelValue: _ctx.isValid,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isValid) = $event)),
                "validate-on": "input",
                onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_img, {
                      class: "mx-auto mb-10",
                      "max-width": "228",
                      src: _ctx.logo
                    }, null, 8, ["src"]),
                    _createVNode(_component_v_card, {
                      class: "mx-auto pa-12 pb-8",
                      elevation: "8",
                      "max-width": "448",
                      rounded: "lg"
                    }, {
                      default: _withCtx(() => [
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-subtitle-1 text-medium-emphasis" }, "Recuperare parolă", -1)),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.identifier,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.identifier) = $event)),
                          density: "compact",
                          placeholder: "Introdu adresa de email sau username",
                          "prepend-inner-icon": "mdi-account-outline",
                          variant: "outlined",
                          readonly: _ctx.loading,
                          rules: [_ctx.required, _ctx.emailOrUser]
                        }, null, 8, ["modelValue", "readonly", "rules"]),
                        _createVNode(_component_v_btn, {
                          block: "",
                          class: "mb-8",
                          color: "blue",
                          size: "large",
                          variant: "tonal",
                          type: "submit",
                          disabled: !_ctx.isValid || _ctx.loading,
                          loading: _ctx.loading
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode(" Trimite ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled", "loading"]),
                        (_ctx.message)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.message), 1))
                          : _createCommentVNode("", true),
                        (_ctx.error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.error), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "onSubmit"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}